import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoutes = () => {
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const currentUser = user || storedUser;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const role = currentUser?.data?.roleId?.name?.toLowerCase();
  const path = location.pathname;

  const isAllowed =
    (role === "superadmin" && path.startsWith("/sadmin")) ||
    (role === "admin" && path.startsWith("/institute")) ||
    (role === "accounts" && path.startsWith("/accounts")) ||
    (role === "admission" && path.startsWith("/admission")) ||
    (role === "parent" && path.startsWith("/student")) ||
    (role === "teacher" && path.startsWith("/teacher"));

  if (isAllowed) {
    return <Outlet />;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoutes;